import { Box, Divider, Paper, SxProps, Theme, Typography } from '@mui/material';

interface Props {
  rows?: number;
  columns?: number;
  title: string;
  actions?: React.ReactNode;
  headerActions?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const PaperCard: React.FC<React.PropsWithChildren<Props>> = ({
  rows = 1,
  columns = 1,
  title,
  headerActions,
  actions,
  children,
  sx,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        padding: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gridRowEnd: `span ${rows}`,
        gridColumnEnd: `span ${columns}`,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          <Typography variant="subtitle1">{title}</Typography>
        </Box>
        <Box>{headerActions}</Box>
      </Box>
      <Divider sx={{ marginY: 1.5 }} />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {children}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>{actions}</Box>
    </Paper>
  );
};
